import API from 'services/API';

export default function confirmRelations(data) {
  return API.request({
    method: 'POST',
    url: '/guardianship/confirm',
    data,
  });
}
